module.exports = __webpack_public_path__ + "img/avon-fighting-breast-cancer-12.b63eb97d.jpg";